<template>
    <div class="inner-container " :class="{ 'min-container': !getTabs }">
     <devisBarEN :documentType="documentType"></devisBarEN>
    </div>
  </template>
  <script>
  import { mapGetters } from 'vuex';
  import devisBarEN from '@/components/ui/devisEN.vue';
  export default {
    components: {
      devisBarEN
    },
    computed: {
      ...mapGetters([
        "getTabs",
      ]),
      documentType() {
        // Check query param first
        if (this.$route.query.type === "facture" || this.$route.query.type === "devis") {
          return this.$route.query.type;
        }
        // Check if path contains "facture"
        if (this.$route.path.includes("facture")) {
          return "facture";
        }
        // Check if path contains "devis"
        if (this.$route.path.includes("devis")) {
          return "devis";
        }
        // Default to null for auto-detection
        return null;
      },
    },
  }
  </script>
  <style scoped>
  .inner-container .content {
    margin: 10px 15px;
    background-color: #fff;
    box-shadow: 1px 1px 24px #00000019;
    border-radius: 5px;
    padding: 14px;
    min-height: 88vh;
    margin-top: 55px;
  }
  </style>